import { module } from 'modujs';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.currentTheme = html.getAttribute('data-theme');
    }

    triggerWidget(e) {

        if(e.way === 'enter') {
            html.classList.add('has-widget-user-open');
            html.classList.add('-footer');
        } else {
            html.classList.remove('has-widget-user-open');
            html.classList.remove('-footer');
        }
    }

    triggerTheme(e) {
        if(e.way === 'enter') {
            html.classList.add('has-footer-widget-open');
            this.call('expand', null, 'Background')
        } else {
            html.classList.remove('has-footer-widget-open');
            this.call('shrink', null, 'Background')
        }
    }
}
